<template>
  <center-popup class="page-bind-mobile"
                :show.sync="visible"
                :close-on-click-modal="false"
                size="extra-large"
  >
    <div class="popup-container">
      <div class="hint">您可获得99元《少年领导力》音频课</div>
      <form class="form"
            @submit.prevent="handleSubmit"
      >
        <div class="form-fields">
          <ym-field class="ym-field"
                    v-model.trim="mobile"
                    type="tel"
                    placeholder="请输入手机号"
                    :attr="{ autocomplete: false }"
                    @keyup.enter.prevent="handleSubmit"
          />
          <ym-field class="ym-field no-pr"
                    v-model.trim="smsCode"
                    placeholder="请输入验证码"
                    :attr="{ autocomplete: false }"
          >
            <div class="sms-btn"
                       id="geetest-verify-sms-btn"
                       plain
                       type="primary"
                       size="small"
                       :disabled="disabledSmsCode"
                 @click="sendSmsCode"
            >{{ smsCodeText }}
            </div>
          </ym-field>
        </div>
        <ym-button class="submit-btn"
                   size="large"
                   type="primary"
                   :disabled="submitDisabled"
                   @click.prevent="handleSubmit"
        >
          现在领取
        </ym-button>
      </form>
    </div>
  </center-popup>
</template>

<script>
  import { mapActions } from 'vuex';
  import { Field, Button, Toast } from 'ym-mint-ui';
  import CenterPopup from '@/components/CenterPopup';
  import { getQuery } from '@/utils';
  import { receiveGift } from '@/services/birthday-2021';
  import geetestMixin from '@/mixins/geetest';
  import validator from '@/utils/validator';

  export default {
    name: 'PageBindMobile',
    mixins: [geetestMixin],
    components: {
      'ym-field': Field,
      'ym-button': Button,
      CenterPopup,
    },
    data() {
      return {
        visible: false,
        mobile: '',
        smsCode: '',
        smsType: 'verify',
      };
    },
    props: {
      messageId: {
        type: Number,
        required: true,
      },
      show: {
        type: Boolean,
        required: true,
      },
    },
    computed: {
      query() {
        return getQuery(this.$route.query);
      },
      disabledSmsCode() {
        return this.mobile !== '' && this.smsCodeDisabled;
      },
      submitDisabled: {
        get() {
          return this.mobile === ''
            || this.smsCode === '';
        },
        set(val) {
          return val;
        },
      },
    },
    watch: {
      show(val) {
        this.visible = val;
      },
      visible(val) {
        this.$emit('update:show', val);
      },
    },
    methods: {
      ...mapActions([
        'BindMobile',
      ]),
      async handleSubmit() {
        if (!validator.isMobile(this.mobile)) {
          Toast('请填写正确的手机号');
          return;
        }
        if (validator.isEmpty(this.smsCode)) {
          Toast('请填写验证码');
          return;
        }
        this.submitDisabled = true;
        try {
          const params = {
            mobile: this.mobile,
            sms_code: this.smsCode,
            messageId: this.messageId,
            type: '2021BirthdayMessage',
          };
          await receiveGift(params);
          this.visible = false;
          this.$emit('receiveGift');
        } catch (e) {
          this.submitDisabled = false;
        }
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .page-bind-mobile {
    background: none;
  }

  .popup-container {
    position: relative;
    margin: 0 auto;
    width: 690px;
    height: 710px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-end;
    background: url('~@/pages/2019/Birthday/assets/img/mobile_popup.png');
    background-size: 100% 100%;
  }

  .hint {
    width: 100%;
    position: absolute;
    top: 180px;
    left: 0;
    font-size: @font-size-extra-small;
    color: @color-white;
    line-height: 1;
    text-align: center;
    text-shadow: 0 1px 2px rgba(54,133,120,0.61);
  }

  .ym-field {
    margin-bottom: @size-base;
    box-sizing: border-box;
    width: 580px;
    height: 90px;
    font-size: @font-size-base;
    color: #6abfa7;
    border-radius: @border-radius-medium;
    padding: 0 30px;
    &.no-pr {
      padding-right: 0;
    }
    /deep/ input {
      &::placeholder {
        color: #6abfa7;
      }
    }
    /deep/ .mint-field-other {
      display: flex;
      align-items: center;
    }
  }

  .sms-btn {
    width: 220px;
    height: 88px;
    border: none;
    color: #4d472d;
    line-height: 88px;
    background: linear-gradient(90deg,rgba(248,230,159,1),rgba(239,216,123,1));
    box-shadow: 0 5px 18px 0 rgba(87,166,144,0.52);
    border-radius: @border-radius-medium;
  }

  .submit-btn {
    margin: 80px auto @size-large;
    width: 220px;
    height: 90px;
    background: linear-gradient(90deg, rgba(248,230,159,1), rgba(239,216,123,1));
    border-radius: 46px;
    box-shadow: 0 5px 18px 0 rgba(87,166,144,0.52);
    color: #4d472d;
  }

  .user-term {
    font-size: @font-size-small;
    color: @color-text-lighter;
  }

  .link {
    color: @color-link;
  }
</style>
